if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.pnpSelectedOptions = null;
      if (this.dataset.pnpPreserveVariantMedia === 'true' || this.dataset.pnpPreserveConnectorMedia === 'true') {
        try {
          const options = JSON.parse(this.dataset.pnpSelectedOptions || 'null');
          if (Array.isArray(options) && options.length) this.pnpSelectedOptions = options.map(String);
        } catch {}
        if (!this.pnpSelectedOptions) this.pnpSelectedOptions = this.getPnpSelectedOptions();
      }
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    getPnpSelectedOptions(currentVariant = null) {
      if (Array.isArray(currentVariant?.options) && currentVariant.options.length) return currentVariant.options.map(String);
      if (currentVariant?.option1 != null) return [currentVariant.option1, currentVariant.option2, currentVariant.option3].filter(value => value != null).map(String);
      const picker = this.productInfo?.querySelector('variant-radios, variant-selects');
      return picker ? Array.from(picker.querySelectorAll('input[type="radio"]:checked, select')).map(input => input.value) : [];
    }

    getPnpThrottleMedia(selected) {
      if (selected[2] !== 'Just Throttle' && selected[2] !== '2 Black Grips') return null;
      const withGrips = selected[2] === '2 Black Grips';
      if (selected[1] === 'Black') return withGrips ? this.dataset.pnpThrottleBlackGripsMedia : this.dataset.pnpThrottleBlackMedia;
      if (selected[1] === 'Carbon Fiber') return withGrips ? this.dataset.pnpThrottleCarbonGripsMedia : this.dataset.pnpThrottleCarbonMedia;
      return null;
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      const variantUpdate = Boolean(prepend || currentVariant);
      const selected = variantUpdate ? this.getPnpSelectedOptions(currentVariant) : [];
      if (variantUpdate && this.dataset.pnpPreserveVariantMedia === 'true') {
        if (selected.length) this.pnpSelectedOptions = selected;
        return;
      }
      if (variantUpdate && this.dataset.pnpPreserveConnectorMedia === 'true' && selected.length) {
        const previous = this.pnpSelectedOptions;
        this.pnpSelectedOptions = selected;
        if (previous && previous.length === selected.length && selected.slice(1).every((value, index) => value === previous[index + 1])) return;
      }
      if (variantUpdate && this.dataset.pnpThrottleMedia === 'true') {
        const throttleMedia = this.getPnpThrottleMedia(selected);
        // Never fall back to a connector photo if a bundle image is not ready.
        if (!throttleMedia) return;
        mediaId = `${this.dataset.section}-${throttleMedia}`;
        prepend = false;
        filtering = false;
      }
      if (variantUpdate && this.dataset.pnpControlMedia === 'true') {
        const controlMedia = selected[1] === 'Switch' ? this.dataset.pnpSwitchMedia : selected[1] === 'Wireless Button' ? this.dataset.pnpWirelessMedia : null;
        if (!controlMedia) return;
        mediaId = `${this.dataset.section}-${controlMedia}`;
        prepend = false;
        filtering = false;
      }
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        console.log('setActiveThumbnail')
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

